var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sidebar-menu-container",
      attrs: { id: "photo-sidebar-menu" }
    },
    [
      _c("div", { staticClass: "sidebar-main-label-grid" }, [
        _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.showRenameInput,
                expression: "!showRenameInput"
              }
            ],
            staticClass: "sidebar-main-label collapsable-ellipsis"
          },
          [_vm._v(_vm._s(_vm.nameActiveProject))]
        ),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showRenameInput,
              expression: "showRenameInput"
            },
            {
              name: "model",
              rawName: "v-model",
              value: _vm.inputName,
              expression: "inputName"
            }
          ],
          staticClass: "photo-sidebar-rename-project",
          attrs: { type: "text", placeholder: _vm.nameActiveProject },
          domProps: { value: _vm.inputName },
          on: {
            change: _vm.renameProject,
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.inputName = $event.target.value
            }
          }
        }),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "edit-project-name-container",
            on: { click: _vm.showInputRename }
          },
          [_c("SVGEditProjectName")],
          1
        )
      ]),
      _vm._v(" "),
      _vm._l(_vm.ImagesProject, function(img, idPhoto) {
        return _c("div", { staticClass: "sidebar-project-img-container" }, [
          _c(
            "div",
            { staticClass: "pretty p-default sidebar-photo-checkbox" },
            [
              _c("input", {
                attrs: { type: "checkbox", id: "cb_" + idPhoto },
                on: {
                  click: function($event) {
                    return _vm.selectCheckBox(idPhoto, $event)
                  }
                }
              }),
              _vm._v(" "),
              _vm._m(0, true)
            ]
          ),
          _vm._v(" "),
          _c("img", {
            staticClass: "sidebar-project-img",
            class: { "active-photo": idPhoto === _vm.idActivePhoto },
            attrs: { src: _vm.urlForPhoto(img.src) },
            on: {
              click: function($event) {
                if ($event.target !== $event.currentTarget) {
                  return null
                }
                return _vm.selectPhoto(idPhoto, $event)
              },
              dblclick: function($event) {
                if ($event.target !== $event.currentTarget) {
                  return null
                }
                return _vm.openPhoto(idPhoto)
              }
            }
          })
        ])
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          attrs: { id: "new-photo-frame" },
          on: {
            click: function($event) {
              return _vm.showModal("photo-add-new-modal")
            }
          }
        },
        [_c("SVGPhotoAddNew")],
        1
      )
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "state p-danger" }, [_c("label")])
  }
]
render._withStripped = true

export { render, staticRenderFns }